import React, { Component } from 'react';
import SearchContainer from './search';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../redux/actions';
import moment from 'moment-timezone';
import Inventory from './models/inventory';
import { HotelService } from 'travco-services';
import serviceUtils from '../utils/service-utils';

class SearchPage extends Component {
    constructor(props) {
        super(props);
        this.hotelRequestNumber = 0;
        this.onEditClick = this.onEditClick.bind(this);
        this.onCreateInventory = this.onCreateInventory.bind(this);
    }

    componentDidMount() {
        if (typeof this.props.match.params.id !== 'undefined') {
            let hotelSearch = {
                hotelId: this.props.match.params.id,
                pageNumber: 1,
                pageSize: 10,
                roomCategoryId: this.props.match.params.rcId ? this.props.match.params.rcId : '',
                dateFrom: moment.tz('Europe/London').toISOString(),
                dateTo: moment.tz('Europe/London').toISOString()
            };

            this.props.actions.searchInventory(hotelSearch, 0).then(() => {
                let obj = { id: this.props.match.params.id };
                this.getHotel(obj);
            });
        } /* else {
			let clearedObject = new Inventory();
			this.props.actions.setModelObject(clearedObject);
		}*/
    }

    getHotel(searchParam) {
        const { token, roomCategory, roomStatus, headerInfo, searchDataTemp, actions } = this.props;

        searchParam = Object.assign(searchParam, { workflowStatus: 'UnPublished', PageSize: 30 });
        let hotelService = new HotelService(token);
        hotelService
            .getHotels(searchParam, this.hotelRequestNumber++)
            .then((response) => {
                return serviceUtils.checkForFetchServerError(
                    response,
                    'Server Error : Unable to contact the hotel service.'
                );
            })
            .then((data) => {
                if (data.requestNumber !== this.hotelRequestNumber - 1) {
                    console.log('Response received not from latest request.');
                    return null;
                }
                let clearedObject = new Inventory();
                clearedObject = {
                    ...clearedObject,
                    inventorySearchData: searchDataTemp,
                    inventory: {
                        ...clearedObject.inventory,
                        hotel: data.hotels[0],
                        roomCategoryId: roomCategory ? roomCategory.id : '',
                        roomCategoryName: roomCategory ? roomCategory.name : '',
                        selectedInventoryStatus: roomCategory ? roomCategory.status : ''
                    }
                };

                let newData = [
                    { name: 'Country', data: data.hotels[0] ? data.hotels[0].country.name : null },
                    {
                        name: 'Region',
                        data:
                            data.hotels[0] && data.hotels[0].city.primaryCountryRegion
                                ? data.hotels[0].city.primaryCountryRegion.name
                                : null
                    },
                    { name: 'City', data: data.hotels[0] ? data.hotels[0].city.name : null },
                    {
                        name: 'Hotel',
                        data: data.hotels[0] ? `${data.hotels[0].name} ( ${data.hotels[0].code} )` : null
                    },
                    {
                        name: 'Currency',
                        data: data.hotels[0] && data.hotels[0].currency ? data.hotels[0].currency.isoCode : null
                    },
                    { name: 'Room category', data: null }
                ];
                const newHeaderInfo = serviceUtils.processHeaderInfo(newData, headerInfo);

                actions.setHeaderInfo(newHeaderInfo);
                actions.setGlobalHotel(data.hotels[0]);

                this.props.actions.setModelObject(clearedObject);
            })
            .catch((error) => {
                console.error(error);
                throw error;
            });
    }

    onEditClick(id) {
        this.props.history.push('/inventory-page/' + id);
        window.location.reload();
    }

    onCreateInventory() {
        this.props.history.push('/inventory-page');
    }

    render() {
        return <SearchContainer onEditClick={this.onEditClick} onCreateInventory={this.onCreateInventory} />;
    }
}

function mapStateToProps(state, ownProps) {
    return {
        model: state.model || null,
        headerInfo: state.globalData.headerInfo || [],
        searchDataTemp:
            state.model.inventorySearchData && state.model.inventorySearchData.length > 0
                ? state.model.inventorySearchData
                : [],
        oidc: state.oidc,
        settings: state.settings,
        data: state.data,
        draft: state.draft,
        token: state.oidc.user !== null ? state.oidc.user.id_token : ''
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);
